module.exports = __webpack_public_path__ + "static/media/background_11.394fb8c1.png";